<template>
  <div>
    <v-dialog v-model="dialogFirstConfirm" persistent scrollable max-width="400">
      <v-card class="py-2">
        <v-card-title class="text-h5">
          <span class="ml-0">Eliminar oportunidad</span>
          <v-spacer />
          <v-btn icon @click="onClose">
            <v-icon small> fas fa-times </v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <h3 class="font-weight-thin">
                ¿Está seguro que
                <span class="font-weight-bold"> desea eliminar la oportunidad</span>?
              </h3>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="mr-2">
          <v-spacer />
          <v-btn rounded text @click="onClose"> Cancelar </v-btn>
          <v-btn color="red" rounded dark @click="onStepSecondConfirm"> Eliminar </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogSecondConfirm" persistent scrollable max-width="400">
      <v-card class="py-2">
        <v-card-title class="text-h5">
          <span class="ml-0">Eliminar oportunidad</span>
          <v-spacer />
          <v-btn icon @click="onClose">
            <v-icon small> fas fa-times </v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <h3 class="font-weight-thin">
                No se puede recuperar una oportunidad una vez eliminada, ¿está seguro que
                <span class="font-weight-bold"> desea eliminar la oportunidad</span>?
              </h3>
            </v-col>
            <v-col v-if="responseErrorMessage" cols="12">
              <v-alert dense text type="error">
                {{ responseErrorMessage }}
              </v-alert>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="mr-2">
          <v-spacer />
          <v-btn rounded text @click="onClose"> Cancelar </v-btn>
          <v-btn :loading="loading" color="red" rounded dark @click="onDelete"> Eliminar </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "DeleteTicket",
  props: {
    dialog: {
      type: Boolean,
      default: true,
    },
    id: {
      type: String,
      default: "",
    },
    fromDrawer: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dialogFirstConfirm: false,
      dialogSecondConfirm: false,
      loading: false,
      responseErrorMessage: null,
    };
  },
  created() {
    this.dialogFirstConfirm = this.dialog;
  },
  methods: {
    ...mapActions(["deleteTicket"]),
    onStepSecondConfirm() {
      this.dialogFirstConfirm = false;
      this.dialogSecondConfirm = true;
    },
    async onDelete() {
      try {
        this.responseErrorMessage = null;
        this.loading = true;

        await this.deleteTicket({ id: this.id });

        this.onClose();

        if (this.fromDrawer) this.$emit("onComplete");
        else this.$router.replace({ name: "tickets" });
      } catch (error) {
        this.responseErrorMessage = error.message || "Ocurrió un problema al eliminar la oportunidad";
      } finally {
        this.loading = false;
      }
    },
    onClose() {
      this.dialogFirstConfirm = false;
      this.dialogSecondConfirm = false;
      this.$emit("update:dialog", false);
    },
  },
};
</script>
